(function ($) {
    function printElem(elem) {
        var mywindow = window.open('', 'PRINT');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(document.getElementById(elem).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        // mywindow.close();

        return true;
    }
    $(document).ready(function () {
        $('#PrintCalendarDates1').click(function () {
            // $('.accordion-item.printable').removeAttr('printable');
            // $(this).parent().parent().attr('id', 'printable');
            // window.print();
            printElem('printable_one');
        });
        $('#PrintCalendarDates2').click(function () {
            // $('.accordion-item.printable').removeAttr('printable');
            // $(this).parent().parent().attr('id', 'printable');
            // window.print();
            printElem('printable_two');
        });
    });
})(jQuery);